module.exports = __webpack_public_path__ + "static/media/no-tutorials-video.9025b2ab.svg";